import { CartProduct } from "./CartProduct";

/**
 * Me hago mi propia clase cart porque la api solo maneja productos sueltos y yo tengo que ordenarlos
 */
export class Cart {
	store_id! : number;
	products! : CartProduct[];
	
	constructor(store_id:number, product:CartProduct) {
		this.store_id = store_id;
		this.products = [product];
	}
}